import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function folderReducer(state = initialState.images, action) {
  switch (action.type) {
    case types.LOAD_IMAGES_SUCCESS: {
      const content = { ...state };
      content.data = action.images;
      content.loading = false;
      return content;
    }

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./library/app/reducers/imageReducer.js